<footer class="site-footer">
  <div class="site-footer__inner">
    <div class="site-footer__brand">
      <img class="site-footer__logo" src="assets/hytec-logo.png" alt="Hytec Power" />

      <nav class="site-footer__socials" aria-label="Hytec Power social media">
        <a
          href="https://www.facebook.com/hytecpowerincorporated/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Hytec Power on Facebook"
        >
          <i class="bi bi-facebook" aria-hidden="true"></i>
        </a>
        <a
          href="https://www.instagram.com/hytecpowerinc_official/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Hytec Power on Instagram"
        >
          <i class="bi bi-instagram" aria-hidden="true"></i>
        </a>
        <a
          href="https://www.tiktok.com/@hytecpowerinc"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Hytec Power on TikTok"
        >
          <i class="bi bi-tiktok" aria-hidden="true"></i>
        </a>
        <a
          href="https://www.youtube.com/@hytecpowerinc/videos"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Hytec Power on YouTube"
        >
          <i class="bi bi-youtube" aria-hidden="true"></i>
        </a>
      </nav>
    </div>

    @for (section of footerSections; track section.key) {
      <section
        class="site-footer__section"
        [class.site-footer__section--mobile-hidden]="section.hideOnMobile"
      >
        <button
          type="button"
          class="site-footer__heading"
          [class.is-open]="isSectionExpanded(section.key)"
          [attr.aria-expanded]="isSectionExpanded(section.key)"
          [attr.aria-controls]="'footer-links-' + section.key"
          (click)="toggleSection(section.key)"
        >
          <span class="site-footer__desktop-label">{{ section.title }}</span>
          <span class="site-footer__mobile-label">{{ section.mobileTitle || section.title }}</span>
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
        </button>

        <ul
          class="site-footer__links"
          [class.is-open]="isSectionExpanded(section.key)"
          [id]="'footer-links-' + section.key"
        >
          @for (link of section.links; track link.label) {
            <li>
              @if (link.children?.length) {
                <span class="site-footer__link-group-title">{{ link.label }}</span>
                <ul class="site-footer__nested-links">
                  @for (childLink of link.children; track childLink.route) {
                    <li>
                      <a [routerLink]="childLink.route">{{ childLink.label }}</a>
                    </li>
                  }
                </ul>
              } @else {
                <a
                  [routerLink]="link.route"
                  [queryParams]="link.queryParams || null"
                  [fragment]="link.fragment || undefined"
                >
                  {{ link.label }}
                </a>
              }
            </li>
          }
        </ul>
      </section>
    }
  </div>

  <div class="site-footer__bottom">
    <p>
      <span>&copy; {{ currentYear }} Hytec Power Incorporated. All rights reserved.</span>
      <span aria-hidden="true">|</span>
      <a routerLink="/privacy-policy">Privacy Policy</a>
      <span aria-hidden="true">|</span>
      <a routerLink="/terms-and-conditions">Terms and Conditions</a>
      <span aria-hidden="true">|</span>
      <button type="button" (click)="openCookiePreferences()">Cookie Preferences</button>
    </p>
  </div>
</footer>
